const letsGoMobileOffersDto = JSON.parse(document.getElementById('lets-go-mobile-offers').dataset.letsGoMobileOffers);

const OffersViewState = {
    LOADED: "loaded",
    LOADING: "loading",
    ERROR: "error"
}

const letsGoMobileOffersCtrl = new Vue({
    el: '#lets-go-mobile-offers',
    data: {
        offers: letsGoMobileOffersDto.offers,
        state: OffersViewState.LOADED,
    },
    computed: {
        isLoading() {
            return this.state === OffersViewState.LOADING;
        },
        isLoaded() {
            return this.state === OffersViewState.LOADED;
        }
    },
    methods: {
        onOfferClick(offer) {
            if (this.isLoading) {
                return;
            }
            this.state = OffersViewState.LOADING;
            let element = document.getElementById("sw-equipment")
            if (element != null && element.checked) {
                window.location = offer.selectorUrl;
            } else {
                window.location = offer.cartAccessUrl;
            }
        }
    }
})
